import { memo } from 'react';
import type { IIconProps } from '../interfaces';

const PlusIcon = (props: IIconProps) => {
  const { width = 20, height = 20, color = 'currentColor' } = props;
  return (
    <svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.62012 9.99902H16.3811"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M10.002 3.61914V16.3801" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default memo(PlusIcon);
